
const initialState = {
    castes: [],
};

const castesReducer = (state = initialState, action) => {
    switch (action.type) {
        case "ADD_CASTES_NAME":
            return state = {
                ...state,
                castes: [action.payload, ...state.castes ],
            }
        case "UPDATE_CASTES_NAME":
            return state = { ...state, castes: state?.castes?.map((castes) => castes._id === action.payload._id ? action?.payload : castes)}

        case "UPDATE_CASTES_STATUS":
            return state = {
                ...state,
                castes: state?.castes?.map((castes) =>
                    castes._id === action.payload._id ? action?.payload : castes
                ),
            }
            case "GET_ALL_CASTES":
                return {
                    ...state,
                    castes: action.payload,
                };
        default:
            return state;
    }
}

export default castesReducer;